var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('v-progress-linear',{staticStyle:{"position":"absolute","z-index":"1"},attrs:{"indeterminate":"","color":"red","height":"7"}}),_c('v-img',{attrs:{"aspect-ratio":16/9,"src":require("@/assets/poster.png")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }